import React, { useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { styles } from "./style";
import clsx from "clsx";

const useStyles = makeStyles(() => createStyles(styles));
type Props = {
  onCutAddTable: () => void;
  onCopyAddTable: () => void;
  onPasteAddTable: () => void;
  cardopen: Boolean;
  cardPaste: Boolean;
  cardTableEnabled: Boolean;
};
const cardMoveTable = ({
  onCutAddTable,
  onCopyAddTable,
  onPasteAddTable,
  cardopen,
  cardPaste,
  cardTableEnabled,
}: Props) => {
  const [copyBtn, setCopyBtn] = useState(false);
  const [cutterBtn, setcutterBtn] = useState(false);
  const [value, setValue] = useState(false);
  const classes = useStyles();
  const onCutBtn = () => {
    onCutAddTable();
    setcutterBtn(true);
    setCopyBtn(false);
  };
  const onCopyBtn = () => {
    setValue(false);
    onCopyAddTable();
    setCopyBtn(true);
  };
  const onPasteBtn = () => {
    if (copyBtn) {
      onPasteAddTable();
    }
    if (cutterBtn) {
      setCopyBtn(false);
      onPasteAddTable();
      setcutterBtn(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className={classes.moveCardTitle}>Acciones para celdas elegidas: </div>

      <Grid container className={classes.moveCardText}>
        <Grid item xs={4}>
          <button
            id="myBtn"
            className={clsx(classes.moveCardBtn, !cardTableEnabled ? classes.btnDisabled : "")}
            disabled={!cardTableEnabled}
            onClick={onCopyBtn}
          >
            <img src="assets/icons/Mask.svg" alt="donlowad-icon" /> Copiar{" "}
          </button>
        </Grid>
        <Grid item xs={4}>
          <div>
            <button
              className={clsx(classes.moveCardBtn, !cardTableEnabled ? classes.btnDisabled : "")}
              disabled={!cardTableEnabled}
              onClick={onCutBtn}
            >
              <img src="assets/icons/Mask.svg" alt="donlowad-icon" />
              Cortar
            </button>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div>
            <button
              onClick={onPasteBtn}
              disabled={!cardopen}
              className={clsx(classes.moveCardBtn, value ? classes.btnDisabled : !cardPaste ? classes.btnDisabled : "")}
            >
              <img src="assets/icons/Mask.svg" alt="donlowad-icon" />
              Pegar{" "}
            </button>
          </div>
        </Grid>
      </Grid>
      <hr className={classes.moveCardhHrTag}></hr>
    </div>
  );
};

export default cardMoveTable;
